import { render, staticRenderFns } from "./rp-users-personal.vue?vue&type=template&id=dc9d81a0"
import script from "./rp-users-personal.vue?vue&type=script&lang=js"
export * from "./rp-users-personal.vue?vue&type=script&lang=js"
import style0 from "./rp-users-personal.vue?vue&type=style&index=0&id=dc9d81a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports